import { render, staticRenderFns } from "./alterar-perfil.vue?vue&type=template&id=7cfa7439&scoped=true&"
import script from "./alterar-perfil.vue?vue&type=script&lang=js&"
export * from "./alterar-perfil.vue?vue&type=script&lang=js&"
import style0 from "./alterar-perfil.vue?vue&type=style&index=0&id=7cfa7439&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa7439",
  null
  
)

export default component.exports